/*
 * GlobalNav messages
 *
 * This contains all the text for the GlobalNav component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.GlobalNav';

export default defineMessages({
  navigation: {
    id: `${scope}.navigation`,
    defaultMessage: 'Hire navigation',
    description:
      'Accessible name distinguishing Hire navigation from the unified product navigation',
  },
  messagesWithUnreadCount: {
    id: `${scope}.messagesWithUnreadCount`,
    defaultMessage: 'Messages, {count, number} unread',
    description: 'Messenger link with the number of unread conversations',
  },
  messagesUnread: {
    id: `${scope}.messagesUnread`,
    defaultMessage: 'Messages, unread',
    description: 'Messenger link indicating an unread SMS message',
  },
  messages: {
    id: `${scope}.messages`,
    defaultMessage: 'Messages',
    description: 'Link to applicant conversations in the account messenger',
  },
  impersonateUser: {
    id: `${scope}.impersonateUser`,
    defaultMessage: 'Impersonate Account/User',
  },
  applicantTable: {
    id: `${scope}.applicantTable`,
    defaultMessage: 'Applicant Table',
  },
  companySettings: {
    id: `${scope}.companySettings`,
    defaultMessage: 'Company Settings',
  },
  helpCenter: {
    id: `${scope}.helpCenter`,
    defaultMessage: 'Help Center',
  },
  giveFeedback: {
    id: `${scope}.giveFeedback`,
    defaultMessage: 'Give Feedback',
  },
  contactSupport: {
    id: `${scope}.contactSupport`,
    defaultMessage: 'Contact Support',
  },
  integrations: {
    id: `${scope}.integrations`,
    defaultMessage: 'Integrations',
  },
  jobsDirectory: {
    id: `${scope}.jobsDirectory`,
    defaultMessage: 'Jobs Directory',
  },
  logOut: {
    id: `${scope}.logOut`,
    defaultMessage: 'Log Out',
  },
  masterApplicantsView: {
    id: `${scope}.masterApplicantsView`,
    defaultMessage: 'Universal Applicant View',
  },
  myProfile: {
    id: `${scope}.myProfile`,
    defaultMessage: 'My Profile',
  },
  openings: {
    id: `${scope}.openings`,
    defaultMessage: 'Openings',
  },
  positions: {
    id: `${scope}.positions`,
    defaultMessage: 'Positions',
  },
  posthire: {
    id: `${scope}.posthire`,
    defaultMessage: 'Posthire',
  },
  screening: {
    id: `${scope}.screening`,
    defaultMessage: 'Screening',
  },
});
